import React, {Fragment} from 'react';
import {bindActionCreators} from "redux";
import connect from "react-redux/es/connect/connect";
import history from "../../../libs/history";
import {fetchCurrentUser, updateCurrentUser} from "../../../creators/currentUser";
import {fetchLocationCountries} from "../../../creators/locations.countries";
import {fetchLocationRegions, resetLocationRegions} from "../../../creators/locations.regions";
import {fetchLocationCounties, resetLocationCounties} from "../../../creators/locations.counties";
import {fetchLocationCities, resetLocationCities} from "../../../creators/locations.cities";

import {Button} from "../Button";
import AskAge from "./components/AskAge";
import AskDescription from "./components/AskDescription";
import AskAvatar from "./components/AskAvatar";
//import AskSex from "./components/AskSex";
import AskOrientation from "./components/AskOrientation";
import AskLookingFor from "./components/AskLookingFor";
import Icon from "../Icon";
import EmailValidation from "./components/EmailValidation";
//import pictureLogo from "../../../images/logoc.png";
import moment from "moment";
import {PageLoader} from "../Loader";
import AskGeoloc from "./components/AskGeoloc";
import _ from "lodash";
import illustration1 from "../../../images/pages/signup/1.jpg";
import illustration2 from "../../../images/pages/signup/2.jpg";
import illustration3 from "../../../images/pages/signup/3.jpg";
import illustration4 from "../../../images/pages/signup/4.jpg";
import illustration5 from "../../../images/pages/signup/5.jpg";
import illustration6 from "../../../images/pages/signup/6.jpg";
import illustration7 from "../../../images/pages/signup/7.jpg";


class SignUpInformations extends React.Component {
    questionsList = [
        /*{
            step: 0,
            name: "gender",
            title: "Vous êtes :",
            allowedToBeIgnored: false,
            img: illustration1
        },*/
        {
            step: 0,
            name: "age1",
            title: "Quel est votre âge ?",
            allowedToBeIgnored: false,
            img: illustration2
        },
        {
            step: 1,
            name: "age2",
            title: "Quel est votre âge ?",
            allowedToBeIgnored: false,
            img: illustration3
        },
        {
            step: 2,
            name: "orientation1",
            title: "Votre sexualité :",
            allowedToBeIgnored: true,
            img: illustration4
        },
        {
            step: 3,
            name: "orientation2",
            title: "Votre sexualité :",
            allowedToBeIgnored: true,
            img: illustration5
        },
        {
            step: 4,
            name: "description",
            title: "Une description pour vous présenter :",
            allowedToBeIgnored: false,
            img: illustration6
        },
        {
            step: 5,
            name: "avatar",
            title: "Votre Avatar :",
            allowedToBeIgnored: true,
            img: illustration7
        },
        {
            step: 6,
            name: "wannameetpeople",
            title: "Souhaitez vous faire des rencontres avec Voissa?",
            allowedToBeIgnored: false,
            img: illustration1
        },
        {
            step: 7,
            name: "lookingfor",
            title: "Vous recherchez ...",
            subtitle: "plusieurs choix disponibles",
            allowedToBeIgnored: true,
            img: illustration2
        },
        {
            step: 8,
            name: "localisation",
            title: "Votre localisation:",
            allowedToBeIgnored: false,
            img: illustration3
        }
    ];

    constructor(props) {
        super(props);
        this.location = {
            country: {_id: "", name: ""},
            region: {_id: "", name: ""},
            county: {_id: "", name: ""},
            city: {_id: "", name: ""}
        };
        this.state = {
            currentQuestion: 0,
            totalQuestion: this.questionsList.length,
            toggleSubmitPopup: false,
            gender: 1,
            orientation1: 0,
            orientation2: 0,
            lookingFor: [],
            description: "",
            birthday: [{
                day: 0,
                month: 0,
                year: 0
            },
                {
                    day: 0,
                    month: 0,
                    year: 0
                }],
            isButtonActive: false,
            avatar: "",
            location: this.location,
            error: false,
            avatarId: null,
            informations : []
        };
        this.nextQuestion = this.nextQuestion.bind(this);
        this.prevQuestion = this.prevQuestion.bind(this);
        this.handleBlockSelection = this.handleBlockSelection.bind(this);
        this.handleData = this.handleData.bind(this);
        this.handleAvatar = this.handleAvatar.bind(this);
        this.handleDate = this.handleDate.bind(this);
        this.handleButton = this.handleButton.bind(this);
        this.handleLocation = this.handleLocation.bind(this);
    }

    componentDidMount() {
        if (!localStorage.getItem(process.env.REACT_APP_TOKEN_NAME)) history.push('/');
        this.props.fetchCurrentUser();
        sessionStorage.setItem(`${process.env.REACT_APP_TOKEN_NAME}_alert`, true);
        this.props.fetchLocationCountries({
            countries: true,
            limit: false,
            sort : "order"
        });
        if (this.props.currentUser.location) {
            if (this.props.currentUser.location.country && this.props.currentUser.location.country._id) {
                this.props.fetchLocationRegions({
                    parentTypeId: this.props.currentUser.location.country._id,
                    regions: true,
                    limit: false,
                    sort : "name"
                });
            }
            if (this.props.currentUser.location.region && this.props.currentUser.location.region._id) {
                this.props.fetchLocationCounties({
                    parentTypeId: this.props.currentUser.location.region._id,
                    counties: true,
                    limit: false,
                    sort : "name"
                });
            }
            if (this.props.currentUser.location.county && this.props.currentUser.location.county._id) {
                this.props.fetchLocationCities({
                    parentTypeId: this.props.currentUser.location.county._id,
                    cities: true,
                    limit: false,
                    sort : "name"
                });
            }
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.currentUserInitialized !== prevProps.currentUserInitialized && this.props.currentUser.profile && this.props.currentUser.profile.isCompleted === true) {
            this.setState({toggleSubmitPopup: true});
        }
        if (this.props.currentUserInitialized !== prevProps.currentUserInitialized) {
            this.setState({
                gender: _.get(this.props, "currentUser.profile.gender") || 1,
                informations :  _.get(this.props, "currentUser.profile.informations") || []
            }, () => this.handleButton());
        }
        // if(this.props.currentUserInitialized && prevProps.currentUser.profile &&  prevProps.currentUser.profile.avatar !== this.props.currentUser.profile.avatar){
        //     this.setState({avatar: this.props.currentUser.profile.avatar});
        // }
    }

    prevQuestion(type) {
        let i = (this.state.gender === 1 || this.state.gender === 2 || this.state.gender === 6) && (this.state.currentQuestion === 1 || this.state.currentQuestion === 2 || this.state.currentQuestion === 4) ? 2 : 1;
        this.setState(prevState => {
            return {currentQuestion: type === 'previous' && prevState.currentQuestion - i, error: false}
        }, () => this.setState({isButtonActive: true}));
    }

    nextQuestion(type) {
        if (this.state.isButtonActive) {
            let i = (this.state.gender === 1 || this.state.gender === 2 || this.state.gender === 6) && (this.state.currentQuestion === 0 || this.state.currentQuestion === 2) ? 2 : 1;
            this.setState(prevState => {
                return {currentQuestion: type === 'next' && prevState.currentQuestion + i, error: false}
            }, () => !this.questionsList[this.state.currentQuestion].allowedToBeIgnored && this.handleButton());
        } else {
            this.setState({error: true});
        }
    }

    handleData(name, value) {
        this.setState({[name]: value}, () => this.handleButton());
    }

    handleAvatar(value) {
        this.setState({avatar: value.preview, avatarId : value.id}, () => this.handleButton());
    }

    handleDate(name, value, index) {
        let birthday = this.state.birthday;
        birthday[index][name] = value;
        this.setState({birthday}, () => this.handleButton());
    }

    handleLocation(event) {
        if (event.target.name === "country") {
            let country = this.props.countries.find(elem => elem._id.toString() === event.target.value.toString()) || {};
            this.props.fetchLocationRegions({parentTypeId: country._id, regions: true, limit: false, sort : "name"});
            this.setState({location: {...this.location, country: {_id: country._id, name: country.name}, region: {_id: "", name: ""}, county: {_id: "", name: ""}, city: {_id: "", name: ""}, coordinate : {type : "Point", coordinates : [0,0]}}});
        }
        if (event.target.name === "region") {
            let region = this.props.regions.find(elem => elem._id.toString() === event.target.value.toString()) || {};
            this.props.fetchLocationCounties({parentTypeId: region._id, counties: true, limit: false, sort : "name"});
            this.setState({location: {...this.state.location, region: {_id: region._id, name: region.name}, county: {_id: "", name: ""}, city: {_id: "", name: ""}, coordinate : {type : "Point", coordinates : [0,0]}}});
        }
        if (event.target.name === "county") {
            let county = this.props.counties.find(elem => elem._id.toString() === event.target.value.toString()) || {};
            this.props.fetchLocationCities({parentTypeId: county._id, cities: true, limit: false, sort : "name"});
            this.setState({location: {...this.state.location, county: {_id: county._id, name: county.name}, city: {_id: "", name: ""}, coordinate : {type : "Point", coordinates : [0,0]}}});
        }
        if (event.target.name === "city") {
            let city = this.props.cities.find(elem => elem._id.toString() === event.target.value.toString()) || {};
            this.setState({
                location: {
                    ...this.state.location,
                    city: {
                        _id: city._id,
                        name: city.name
                    },
                    coordinate : city.coordinate
                }
            });
        }
    }

    handleBlockSelection(id, type) {
        let typeValue = this.state[type];
        if (type === "gender") {
            this.setState({[type]: id}, () => this.handleButton());
        }
        if (type === "orientation1" || type === "orientation2") {
            this.setState({[type]: id}, () => this.handleButton());
        }
        if (type === "lookingFor") {
            this.setState({[type]: [...typeValue, id]}, () => this.handleButton());
            if (typeValue.includes(id)) {
                let newTypeValue = typeValue.filter(item => item !== id);
                this.setState({[type]: newTypeValue}, () => this.handleButton())
            }
        }
    }

    handleButton() {
        let birthday1 = moment().diff(moment(`${this.state.birthday[0].year}-${this.state.birthday[0].month}-${this.state.birthday[0].day}`) , 'year');
        let birthday2 = moment().diff(moment(`${this.state.birthday[0].year}-${this.state.birthday[0].month}-${this.state.birthday[0].day}`) , 'year');
       /* if (this.state.currentQuestion === 0 && this.state.gender === 0) {
            this.setState({isButtonActive: false})
        } else*/
        if (this.state.currentQuestion === 4 && this.state.description.length <= 19) {
            this.setState({isButtonActive: false})
        } else if (this.state.currentQuestion === 0 && (this.state.birthday[0].day === 0 || this.state.birthday[0].month === 0 || this.state.birthday[0].year === 0 || birthday1 <18 )) {
            this.setState({isButtonActive: false})
        } else if (this.state.currentQuestion === 1 && (((this.state.gender === 3 || this.state.gender === 4 || this.state.gender === 5) && (this.state.birthday[0].day === 0 || this.state.birthday[0].month === 0 || this.state.birthday[0].year === 0 || birthday1 <18) && (this.state.birthday[1].day === 0 || this.state.birthday[1].month === 0 || this.state.birthday[1].year === 0 || birthday2 <18)) || ((this.state.gender === 1 || this.state.gender === 2 || this.state.gender === 6) && (this.state.birthday[0].day === 0 || this.state.birthday[0].month === 0 || this.state.birthday[0].year === 0 || birthday1 <18)))) {
            this.setState({isButtonActive: false})
        } else {
            this.setState({isButtonActive: true, error: false})
        }
    }

    submit() {
        this.setState({toggleSubmitPopup: true});
        let informations = this.state.informations;
        informations[0] = {
            ...informations[0],
            orientation: this.state.orientation1,
            birthday: moment(`${this.state.birthday[0].year}-${this.state.birthday[0].month}-${this.state.birthday[0].day}`)
        };

        if (this.state.gender === 3 || this.state.gender === 4 || this.state.gender === 5) {
            /*informations.push(
                {
                    orientation: this.state.orientation2,
                    birthday: moment(`${this.state.birthday[1].year}-${this.state.birthday[1].month}-${this.state.birthday[1].day}`)
                }
            )*/
            informations[1] = {
                ...informations[1],
                orientation: this.state.orientation2,
                birthday: moment(`${this.state.birthday[1].year}-${this.state.birthday[1].month}-${this.state.birthday[1].day}`)
            }
        }

        let currentUser = {
            profile: {
                avatarId : _.get(this.props.currentUser, "profile.avatarId"),
                gender: _.get(this.state,"gender") || 1,
                lookingFor: this.state.lookingFor,
                description: this.state.description,
                isCompleted : true,
                informations
            },
            setting : {
                appearInDating : this.state.lookingFor.length
            },
            location: {
                ...this.state.location,
                coordinate: {
                    type: "Point",
                    coordinates: [this.state.latitude || 0, this.state.longitude || 0]
                }
            },
        };
        // if(this.state.fileAvatar){
        //     currentUser = {
        //         ...currentUser,
        //         "_files" : {
        //             "profile.avatar" : this.state.fileAvatar
        //         }
        //     }
        // }

       this.props.updateCurrentUser(currentUser);
        // this.setState({currentUser: {email: "test"}}, ()=>this.setState({toggleSubmitAlert: false}));
        // history.push("/me");
    }

    render() {
        let completedStep = this.state.toggleSubmitPopup ? 100 : Math.round((this.state.currentQuestion + 1) / (this.state.totalQuestion + 2) * 100);
        let currentQuestion = this.state.currentQuestion;

        let step = [
            /*<AskSex gender={this.state.gender} handleBlockSelection={this.handleBlockSelection}/>,*/
            <AskAge gender={this.state.gender} birthday={this.state.birthday[0]} currentIndex={0}
                    handleDate={this.handleDate} currentQuestion={this.state.currentQuestion}/>,
            <AskAge gender={this.state.gender} birthday={this.state.birthday[1]} currentIndex={1}
                    handleDate={this.handleDate} currentQuestion={this.state.currentQuestion}/>,
            <AskOrientation gender={this.state.gender} orientation1={this.state.orientation1} singleOrientation={true}
                            currentQuestion={this.state.currentQuestion}
                            handleBlockSelection={this.handleBlockSelection}/>,
            <AskOrientation gender={this.state.gender} orientation1={this.state.orientation1}
                            orientation2={this.state.orientation2}
                            singleOrientation={this.state.gender === 1 || this.state.gender === 2 || this.state.gender === 6}
                            currentQuestion={this.state.currentQuestion}
                            handleBlockSelection={this.handleBlockSelection}/>,
            <AskDescription description={this.state.description} handleData={this.handleData}/>,
            <AskAvatar avatar={this.state.avatar}
                       gender={this.state.gender} handleData={this.handleAvatar}/>,
            <div id={"wannaMeet"}>
                <div className={"btn-group"}>
                    <Button size={"big"}
                            btnStyle={"primary-reverse"}
                            onClick={() => this.setState({currentQuestion: 8})}
                            content={"Oui"}/>
                    <Button size={"big"}
                            btnStyle={"grey"}
                            onClick={() => this.submit()}
                            content={"Pas pour le moment"}/>
                </div>
            </div>,
            <AskLookingFor lookingFor={this.state.lookingFor} handleBlockSelection={this.handleBlockSelection}/>,
            <AskGeoloc handleLocation={this.handleLocation}
                       counties={this.props.counties}
                       countries={this.props.countries}
                       regions={this.props.regions}
                       cities={this.props.cities}
                       location={this.state.location}/>
        ];
        let birthday1 = 0;
        let birthday2 = 0;
        if(this.state.currentQuestion === 0){
            birthday1 = moment().diff(moment(`${this.state.birthday[0].year}-${this.state.birthday[0].month}-${this.state.birthday[0].day}`) , 'year');
            birthday2 = moment().diff(moment(`${this.state.birthday[0].year}-${this.state.birthday[0].month}-${this.state.birthday[0].day}`) , 'year');
        }

        return !this.props.currentUserInitialized ? <PageLoader/> : (
            <Fragment>
                <div className="main-wrapper">

                    <div id={"SignUpInformations"}>
                        <div className={"head-title display-2"}>
                            {this.questionsList[this.state.currentQuestion].title}
                            {this.questionsList[this.state.currentQuestion].subtitle && <span
                                className={"subtitle"}>{this.questionsList[this.state.currentQuestion].subtitle}</span>}
                        </div>
                        <div className={"topline"}>
                            <div className={"step-progression"}>
                                <div className={"percentage-number"}>
                                    {completedStep}%
                                </div>
                                <div className={"progress-bar"}
                                     style={{width: `${completedStep === 0 ? 1 : completedStep}%`}}/>
                            </div>
                            {/*<span className={"questions-count"}>Question {this.state.currentQuestion} / {this.state.totalQuestion}</span>*/}
                        </div>
                        <div className={"form-content"}>
                            {step[currentQuestion]}
                            {this.state.error && (
                                <span className={"error"}>
                                    {/*this.state.currentQuestion === 0 && (
                                        "Vous n'avez pas choisi votre sexe"
                                    )*/}
                                    {this.state.currentQuestion === 0 && Number.isNaN(birthday1) && (
                                        "Vous n'avez pas rempli l'âge"
                                    )}
                                    {this.state.currentQuestion === 0 && !Number.isNaN(birthday1) && birthday1 < 18 && (
                                        "Vous devez être majeur"
                                    )}

                                    {this.state.currentQuestion === 1  &&Number.isNaN(birthday2) && (((this.state.gender === 1 || this.state.gender === 2 || this.state.gender === 6)) || ((this.state.gender === 3 || this.state.gender === 4 || this.state.gender === 5))) && (
                                        "Vous n'avez pas rempli l'âge"
                                    )}
                                    {this.state.currentQuestion === 1  && !Number.isNaN(birthday2) && birthday2 < 18 && (((this.state.gender === 1 || this.state.gender === 2 || this.state.gender === 6) ) || ((this.state.gender === 3 || this.state.gender === 4 || this.state.gender === 5))) && (
                                        "Vous devez être majeur"
                                    )}
                                    {this.state.currentQuestion === 4 && (
                                        "Vous n'avez pas rempli votre description"
                                    )}
                                </span>
                            )}
                        </div>
                        <div className={"btn-group"}>
                            {this.state.currentQuestion !== 0 && (
                                <Button className={"previous"}
                                        btnStyle={"grey"}
                                        size={"medium"}
                                        icon={"arrow-left"}
                                        onClick={this.state.currentQuestion !== 0 ? this.prevQuestion.bind(this, 'previous') : undefined}
                                        content={"Précédent"}/>
                            )}
                            {this.questionsList[this.state.currentQuestion].allowedToBeIgnored &&
                            <Button className={`ignore`}
                                    btnStyle={"grey"}
                                    icon={"close"}
                                    size={"medium"}
                                    iconSide={"right"}
                                    onClick={this.nextQuestion.bind(this, 'next')}
                                    content={"Ignorer"}/>
                            }
                            {this.state.currentQuestion !== 6 && (
                                <Fragment>
                                    {this.state.currentQuestion !== this.state.totalQuestion - 1 &&
                                    <Button className={`next ${this.state.currentQuestion === 0 ? 'full' : ''}`}
                                            btnStyle={"primary-reverse"}
                                            disabled={!this.state.isButtonActive}
                                            icon={"arrow-right"}
                                            size={"medium"}
                                            iconSide={"right"}
                                            onClick={this.nextQuestion.bind(this, 'next')}
                                            content={"Suivant"}/>
                                    }
                                    {this.state.currentQuestion === this.state.totalQuestion - 1 &&
                                    <Button className={"next"}
                                            btnStyle={"primary-reverse"}
                                            size={"medium"}
                                            iconSide={"right"}
                                            icon={"check"}
                                            onClick={() => this.submit()}
                                            content={"Terminer l'inscription"}/>
                                    }
                                </Fragment>
                            )}
                        </div>
                        <EmailValidation
                            toggle={this.state.toggleSubmitPopup}
                            handleClose={() => history.push('/mon-profil')}
                            avatar={this.state.avatar}
                            gender={this.state.gender}
                            email={this.props.currentUser.email.address}
                            signup={true}
                        />
                    </div>
                </div>
                <div className={"voissa-advantage"}>
                    <div className={"voissa-touch-img"}>
                        <img src={this.questionsList[currentQuestion].img} alt={"voissa touch"}/>
                    </div>
                    <div className={"free"}>
                        <div className={"free-wrapper"}>
                            <div className={"text-icon"}><Icon type={"free"}/> C'EST GRATUIT</div>
                            <div className={"text-icon"}><Icon type={"incognito"}/> ANONYME</div>
                            <div className={"text-icon"}><Icon type={"secure"}/> 100% SECURISÉ</div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

const mapStateToProps = state => ({
    currentUser: state.currentUser.data,
    currentUserInitialized: state.currentUser.initialized,

    countries: state.locationCountries.data,
    regions: state.locationRegions.data,
    counties: state.locationCounties.data,
    cities: state.locationCities.data
});


const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchCurrentUser,
    updateCurrentUser,

    fetchLocationCountries,
    fetchLocationRegions,
    fetchLocationCounties,
    fetchLocationCities,
    resetLocationRegions,
    resetLocationCounties,
    resetLocationCities
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SignUpInformations);

